import {IDataAutotestProps} from 'core/types';
import React, {CSSProperties, FC, createContext, ReactNode} from 'react';

export const SkeletonContext = createContext<boolean>(false);

interface IProps {
    children: ReactNode | ReactNode[];
    disabled?: boolean;
    className?: string;
    fadeInEffect?: boolean;
    color?: string;
    radius?: number | string;
    isContentHidden?: boolean;
}

export const SkeletonWrapper: FC<IProps & IDataAutotestProps> = ({
    children,
    className,
    disabled = false,
    fadeInEffect = false,
    color,
    radius = 8,
    isContentHidden = false,
}) => {
    if (disabled) {
        return <div className={className}>{children}</div>;
    }

    const radiusValue = 'number' === typeof radius ? `${radius}px` : radius;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const style = {'--skeleton-color': color, '--skeleton-radius': radiusValue} as CSSProperties;

    return (
        <div
            className={className}
            style={style}
            data-skeleton-item-fadein-effect={fadeInEffect}
            data-skeleton-content-hidden={isContentHidden}
            data-skeleton-wrapper={true}
        >
            <SkeletonContext.Provider value={true}>{children}</SkeletonContext.Provider>
        </div>
    );
};
